<template>
  <el-config-provider :locale="locale" :button="button">
    <router-view v-slot="{ Component, route }">
      <component v-if="route.meta.requiresAuth === false" :is="Component" />
      <el-container v-else>
        <ElMenu class="hidden-xs-only" />
        <el-container>
          <el-header class="header" height="64px">
            <el-space v-if="!isMobileObj.any" :size="0" @click="provinceHandle">
              <img src="@/assets/img/area.png" alt="" />
              <span>IP：{{ userInfo && (userInfo.province || '设置') }}</span>
            </el-space>
            <!-- <el-icon v-if="isMobileObj.any" @click="drawer = !drawer">
              <Menu />
            </el-icon> -->
            <el-dropdown class="dropdown">
              <el-space>
                <!-- <el-badge
                  @click="DrawerTableArticleReactive.visible = true"
                  class="mr20 cp"
                  :value="userInfo?.unlook"
                >
                  <img src="@/assets/img/article_icon.png" />
                </el-badge> -->
                <img src="@/assets/img/account_icon.png" />
                <!-- <el-icon class="account_icon" :size="24"><User /></el-icon> -->
                <div class="f18">{{ userInfo && userInfo.cname }}</div>
                <el-icon :size="16"><ArrowDown /></el-icon>
              </el-space>
              <template #dropdown>
                <el-dropdown-menu class="dropdown_menu">
                  <!-- <el-dropdown-item @click="passwordVisible = true">
                    修改密码
                  </el-dropdown-item> -->
                  <!-- <el-dropdown-item>
                    <img class="el-icon" src="@/assets/img/head_icon1.svg" />
                    个人资料
                  </el-dropdown-item> -->
                  <el-dropdown-item @click="passwordVisible = true">
                    <img class="el-icon" src="@/assets/img/head_icon2.svg" />
                    修改密码
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click="DrawerTableArticleReactive.visible = true"
                  >
                    <img class="el-icon" src="@/assets/img/head_icon4.png" />
                    更新日志
                  </el-dropdown-item>
                  <el-dropdown-item class="loginout" @click="loginoutHandle">
                    <img class="el-icon" src="@/assets/img/head_icon1.svg" />
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <img
              class="collapse"
              src="@/assets/img/collapse.svg"
              v-if="isMobileObj.any"
              @click="drawer = !drawer"
            />
          </el-header>
          <el-main>
            <transition
              name="custom-classes-transition"
              enter-active-class="animate__animated animate__faster fadeInRight20"
            >
              <component :is="Component" :key="route.path" />
            </transition>
          </el-main>
        </el-container>
      </el-container>
    </router-view>
    <el-drawer
      custom-class="drawer_menu"
      v-model="drawer"
      direction="rtl"
      size="240"
      :show-close="false"
      :with-header="false"
    >
      <ElMenu />
    </el-drawer>
    <PassWord v-if="passwordVisible" v-model:visible="passwordVisible" />
    <PopupProvince v-model="PopupProvinceReactive.visible"></PopupProvince>
    <DrawerTableArticle
      v-if="DrawerTableArticleReactive.visible"
      v-model="DrawerTableArticleReactive.visible"
    ></DrawerTableArticle>
  </el-config-provider>
</template>

<script setup>
import { ref, toRefs, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import isMobile from 'ismobilejs'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { Menu, User, ArrowDown } from '@element-plus/icons-vue'
import ElMenu from '@/components/ElMenu'
import PassWord from '@/components/PassWord'
import PopupProvince from '@/components/PopupProvince'
import { loginout } from '@/utils/api'
import DrawerTableArticle from '@/components/DrawerTableArticle'

const store = useStore()
const { state } = store
const { userInfo } = toRefs(state)

const router = useRouter()

const isMobileObj = isMobile(window.navigator)

const locale = reactive(zhCn)
const button = reactive({
  autoInsertSpace: true,
})
const drawer = ref(false)

const loginoutHandle = () => {
  loginout().then(({ data: res }) => {
    router.replace({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    })
  })
}

const passwordVisible = ref(false)

const PopupProvinceReactive = reactive({
  visible: false,
})
const provinceHandle = () => {
  PopupProvinceReactive.visible = true
}

const DrawerTableArticleReactive = reactive({
  visible: false,
})
</script>

<style lang="scss">
@import '@/assets/css/default.scss';
@import '../node_modules/@pqina/pintura/pintura.css';

html.dark {
  --el-bg-color: #121f38 !important;
  background-color: #0c1429;
  --el-fill-color-lighter: #272c4a !important;
  --el-border-color: #223c6c !important;
  --el-border-color-light: #223c6c !important;
  --el-color-info: #f1f2f3 !important;
  --el-bg-color-overlay: #091a3b !important;
}
.el-table {
  --el-table-header-bg-color: #272c4a !important;
  --el-table-border-color: #2f4772 !important;
  --el-table-row-hover-bg-color: #0d152c !important;
  --el-table-current-row-bg-color: #0d152c !important;
  --el-table-text-color: #fff !important;
}
.el-switch {
  --el-switch-off-color: #fff !important;
  .el-switch__core .el-switch__action {
    background-color: #ccc;
  }
  &.is-checked .el-switch__core .el-switch__action {
    background-color: #fff;
  }
}

.main {
  background-color: #10163a;
  border: 1px solid #223c6c;
}
.tip {
  background: #161e35;
  line-height: 30px;
  padding: 10px 20px;
  border-radius: 5px;
  color: #afc1be;
  width: 100%;
  border: 1px solid #223c6c;
}
.space__item {
  max-width: 100%;
}
.hover {
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.6;
  }
}
@keyframes fadeInRight20 {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.fadeInRight20 {
  animation-name: fadeInRight20;
}
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .account_icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #4664f4;
    color: #fff;
    svg {
      height: 0.8em;
      width: 0.9em;
    }
  }
}
.drawer_menu {
  .el-drawer__body {
    padding: 0;
  }
}
.el-drawer.drawer {
  .el-drawer__title {
    font-size: 22px;
    color: #fff;
    font-weight: bold;
    @extend .title_line;
  }
}

.title_line {
  position: relative;
  &::before {
    content: '';
    width: 3px;
    height: 23px;
    background: #016fed;
    position: absolute;
    left: -20px;
    top: 50%;
    margin-top: -11.5px;
  }
  .c_cfdff0 {
    color: #cfdff0;
  }
}

.header {
  background-color: #0d162d;
}
.dropdown_menu {
  --el-font-size-base: 16px;
  --el-dropdown-menuItem-hover-color: #5fa5fa;
  .el-icon {
    font-size: 24px;
    margin-right: 11px;
  }
  .loginout {
    border-top: 1px solid #223c6c;
    --el-text-color-regular: #5fa5fa;
    --el-dropdown-menuItem-hover-color: #0050ab;
  }
}
.new_dialog {
  --el-text-color-regular: #fff;
  --el-dialog-bg-color: #0c1a35 !important;
  .el-dialog__title {
    font-size: 24px;
    font-weight: bold;
    @extend .title_line;
  }
  .el-message-box__title {
    --el-messagebox-font-size: 24px;
    font-weight: bold;
    --el-messagebox-title-color: #fff;
    @extend .title_line;
    &::before {
      left: -15px;
    }
  }
  .el-input {
    --el-input-height: 40px;
    --el-font-size-base: 16px;
    --el-input-text-color: #fff;
    --el-input-border-color: #4b577a;
    --el-input-hover-border-color: #fff;
    --el-input-focus-border-color: #fff;
    --el-input-bg-color: #182d55;
    input::-webkit-input-placeholder,
    textarea::-webkit-input-placeholder {
      color: #b9ccff;
    }
  }
  .el-button {
    /* width: 98px; */
    height: 40px;
    --el-border-radius-base: 3px;
    --el-button-border-color: #5981fa;
    --el-button-hover-bg-color: transparent;
    --el-button-hover-border-color: #5981fa;
    --el-button-hover-text-color: #8eaaff;
  }
  .el-button--primary {
    --el-button-bg-color: #1352ff;
    --el-button-border-color: #1352ff;
    --el-button-hover-bg-color: #1352ff;
    --el-button-hover-border-color: #1352ff;
    --el-button-hover-text-color: #aac1ff;
  }
  .el-form-item__label {
    height: 40px;
    line-height: 40px;
  }
  .el-textarea__inner {
    min-height: 94px !important;
  }
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.form_item_tip {
  color: #6a7e94;
}
.flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
@font-face {
  font-family: 'DIN Alternate Bold';
  src: url('https://u.xiansuotu.com/fonts/DIN Alternate Bold.ttf');
}
@font-face {
  font-family: font1;
  src: url('https://u.xiansuotu.com/fonts/SourceHanSans-Normal.otf');
}
@font-face {
  font-family: font2;
  src: url('https://u.xiansuotu.com/fonts/SourceHanSans-Bold.otf');
}
@font-face {
  font-family: font3;
  src: url('https://u.xiansuotu.com/fonts/庞门正道标题体2.0增强版.ttf');
}
@font-face {
  font-family: font4;
  src: url('https://u.xiansuotu.com/fonts/站酷快乐体.ttf');
}
@font-face {
  font-family: font5;
  src: url('https://u.xiansuotu.com/fonts/站酷高端黑.ttf');
}
@font-face {
  font-family: font6;
  src: url('https://u.xiansuotu.com/fonts/SourceHanSansCN-Regular.otf');
}
@font-face {
  font-family: font7;
  src: url('https://u.xiansuotu.com/fonts/SourceHanSerifTW-Bold.otf');
}
@font-face {
  font-family: font8;
  src: url('https://u.xiansuotu.com/fonts/SourceHanSerifTW-Regular.otf');
}
@font-face {
  font-family: font9;
  src: url('https://u.xiansuotu.com/fonts/字魂55号-龙吟手书.ttf');
}
@font-face {
  font-family: font10;
  src: url('https://u.xiansuotu.com/fonts/字魂143号-正酷超级黑.ttf');
}
@font-face {
  font-family: font11;
  src: url('https://u.xiansuotu.com/fonts/字魂151号-联盟综艺体.ttf');
}

$font: (
  1,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  15,
  16,
  17,
  18,
  19,
  20,
  59,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94
);
@each $i in $font {
  @font-face {
    font-family: aifont#{$i};
    /* src: url('@/assets/aifont/font/#{$i}.woff2'); */
    src: url('https://xstdsp-static.oss-cn-shanghai.aliyuncs.com/v2/aifont/#{$i}.woff2');
  }
}

@media screen and (max-width: 768px) {
  .header {
    background-color: #0d203b;
  }
  #app {
    .data_list {
      .item {
        margin-bottom: 20px !important;
      }
    }
  }
}
.video_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  > .item {
    width: 271px;
    height: 316px;
    background: #0c224c;
    border-radius: 4px;
    border: 1px solid #334f84;
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    &.checked::before {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 32px;
      height: 29px;
      z-index: 9;
      background: url(@/assets/img/material_icon3.png) no-repeat;
    }
    .cover {
      height: 247px;
      padding: 27px 20px 7px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .title {
      border-top: 1px solid #334f84;
      height: 37px;
      line-height: 37px;
      padding: 0 14px;
      @extend .ellipsis;
      &::before {
        content: '';
        width: 15px;
        height: 15px;
        background: url(@/assets/img/material_list_icon1.png) no-repeat;
        display: inline-block;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
    .control {
      height: 30px;
      display: flex;
      border-top: 1px solid #334f84;
      div {
        flex: 1;
        border-left: 1px solid #334f84;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        &:first-child {
          border-left: 0;
        }
        &:hover {
          opacity: 0.8;
        }
      }
      .edit {
        background-image: url(@/assets/img/material_list_icon2.png);
      }
      .preview {
        background-image: url(@/assets/img/material_list_icon3.png);
      }
      .delete {
        background-image: url(@/assets/img/material_list_icon4.png);
      }
      .cover_change {
        background-image: url(@/assets/img/material_list_icon5.png);
      }
    }
    .count {
      position: absolute;
      left: 0;
      top: 0;
      height: 25px;
      line-height: 25px;
      background: #0041bf;
      border-radius: 4px 0px 4px 0px;
      padding: 0 7px;
    }
    .count_dropdown {
      position: absolute;
      left: 0;
      top: 0;
      height: 29px;
      line-height: 29px;
      background: rgba(0, 65, 191, 0.8);
      border-radius: 3px 0px;
      padding: 0 11px;
      width: 133px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:hover {
        .menu {
          visibility: visible;
          opacity: 1;
        }
        .el-icon {
          transform: rotate(180deg);
        }
      }
      .el-icon {
        transition: all 0.3s;
      }
      > .ellipsis {
        font-weight: bold;
      }
      .menu {
        position: absolute;
        left: 0;
        top: 100%;
        width: 133px;
        font-size: 12px;
        visibility: hidden;
        opacity: 0;
        transition: all 0.3s;
        background: rgba(0, 65, 191, 0.8);
        padding: 5px 11px;
        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #002266;
          margin-bottom: 6px;
          padding: 0 5px;
          border-radius: 3px;
          .info {
            display: flex;
            align-items: center;
            color: #9cbeff;
            flex: none;
            img {
              margin-right: 2px;
            }
          }
        }
      }
    }
  }
}

#app {
  color: #fff;
  .pintura-editor {
    --color-background: 0, 0, 0;
    --color-foreground: 255, 255, 255;
  }
  .content {
    padding: 15px;
    margin: 0;
    line-height: normal;
  }
  .el-aside {
    transition: width 0.3s;
    flex: none;
  }
  .el-menu {
    width: 100%;
    /* border-right: 0; */
  }
  .el-table th.el-table__cell {
    background-color: #0c2e96;
    line-height: 28px;
    border-bottom: 0;
    color: #fff;
  }
  .article_dialog {
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .time {
      font-size: 16px;
      margin-bottom: 25px;
      opacity: 0.5;
    }
    .content {
      font-size: 16px;
      margin: 0;
      padding: 0;
      line-height: 21px;
    }
  }
  .el-button {
    height: 40px;
    --el-font-size-base: 16px;
    --el-button-font-weight: bold;

    --el-button-text-color: #fff;
    --el-button-hover-text-color: #5981fa;
    --el-button-active-text-color: #5981fa;

    --el-button-bg-color: transparent;
    --el-button-hover-bg-color: transparent;
    --el-button-active-bg-color: transparent;

    --el-button-border-color: #5981fa;
    --el-button-hover-border-color: #5981fa;
    --el-button-active-border-color: #5981fa;
    &:focus {
      --el-button-hover-text-color: #fff;
      --el-button-hover-bg-color: #1352ff;
      --el-button-hover-border-color: #1352ff;
    }
    &.el-button--primary {
      --el-button-hover-text-color: #9fbaff;
      --el-button-active-text-color: #9fbaff;

      --el-button-bg-color: #1352ff;
      --el-button-hover-bg-color: #1352ff;
      --el-button-active-bg-color: #1352ff;

      --el-button-border-color: #1352ff;
      --el-button-hover-border-color: #1352ff;
      --el-button-active-border-color: #1352ff;
    }
    &.btn2 {
      height: 36px;
      --el-button-font-weight: normal;
    }
    &.btn3 {
      height: 32px;
      --el-button-font-weight: normal;
      --el-font-size-base: 14px;
    }
  }
  .search {
    width: 292px;
    --el-input-height: 40px;
    --el-input-border-color: #4b577a;
    --el-input-hover-border-color: #5981fa;
    --el-input-focus-border-color: #5981fa;
    --el-input-text-color: #fff;
    --el-font-size-base: 16px;
  }
  .link {
    min-width: 113px;
    height: 33px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    font-size: 16px;
    &.link1 {
      border: 1px solid #386aff;
      background: rgba(89, 129, 250, 0.2);
      &:hover,
      &:active,
      &:focus {
        background: rgba(0, 62, 248, 0.2);
        color: #5fa5fa;
      }
    }
    &.link2 {
      border: 1px solid #2aa1d6;
      background: rgba(102, 141, 139, 0.2);
      &:hover,
      &:active,
      &:focus {
        background: rgba(47, 156, 151, 0.2);
        color: #81bcd5;
      }
    }
    img {
      margin-right: 6px;
    }
  }
  .data_list {
    &.mobile {
      margin-bottom: 20px;
      .info {
        flex-direction: column;
        align-items: flex-start !important;
        .text {
          border-bottom: 0;
          padding-bottom: 5px;
          &::after {
            display: none;
          }
        }
      }
    }
    .item {
      background-color: #171c3c;
      min-height: 161px;
      padding: 22px;
      display: flex;
      align-items: center;
      border: 1px solid #223c6c;
      .text {
        font-size: 16px;
        white-space: nowrap;
      }
      .number {
        font-size: 36px;
        font-weight: bold;
        font-family: 'DIN Alternate Bold';
      }
      .line {
        height: 3px;
        background: #a8afbb;
        position: relative;
        &::after {
          content: '';
          height: 3px;
          background: #016fed;
          position: absolute;
          width: 62px;
          left: 0;
          top: 0;
        }
      }
    }
  }
  .box {
    background-color: #171c3c;
    padding: 20px;
    border: 1px solid #223c6c;
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 25px;
      @extend .title_line;
      &.title2 {
        &::before {
          display: none;
        }
      }
      span {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }
  .tabs {
    > .el-tabs__header {
      margin-bottom: 0;
      .el-tabs__item {
        height: 60px;
        font-weight: bold;
        --el-color-primary: #fff;
        --el-font-size-base: 24px;
        padding: 0;
        .item {
          display: block;
          line-height: 60px;
          padding: 0 20px;
        }
      }
      .el-tabs__nav-wrap::after,
      .el-tabs__active-bar {
        display: none;
      }
      @extend .title_line;
      &:before {
        left: 0;
      }
      .el-tabs__nav {
        display: flex;
      }
    }
  }
  .form_row {
    .el-form-item__content > *,
    .el-color-picker__trigger,
    .full {
      width: 100%;
    }
  }
  .pintura_dialog {
    display: flex;
    flex-direction: column;
    .el-dialog__body {
      flex: auto;
      height: calc(80vh - 100px);
    }
  }
  .v2_btn {
    width: auto;
    height: 40px;
    background: #1352ff;
    border: 0;
    padding: 0 28px;
  }
  .contain {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .el-drawer {
    --el-drawer-bg-color: #121f38;
  }
  .drawer_untitle {
    .el-tabs__item {
      height: 32px;
      line-height: 32px;
      padding: 0 42px;
      color: #fff;
    }
    .el-drawer__header {
      position: absolute;
      width: auto;
      top: 0;
      right: 0;
      z-index: 9;
    }
    .el-tabs--card > .el-tabs__header {
      border-bottom: 0;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border: 0;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      background: #1352ff;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item {
      background: #06142e;
      &:hover {
        opacity: 0.8;
      }
    }
    .el-drawer__footer {
      .divider {
        margin-left: -20px;
        margin-right: -20px;
      }
      .el-divider {
        margin-top: 0;
      }
    }
  }

  .release_form {
    .h2 {
      font-size: 20px;
      margin-bottom: 25px;
      font-weight: bold;
    }
    .input {
      max-width: 502px;
      --el-input-bg-color: #182d55;
      --el-input-border-color: #2f4e86;
    }
    .el-form-item {
      margin-bottom: 24px;
    }
  }

  .auth_radio {
    width: 275px;
    height: 134px;
    background: #0c1a35;
    border-radius: 4px;
    border: 1px solid #2e66cd;
    margin-right: 22px;
    margin-bottom: 22px;
    padding: 20px;
    --el-color-primary: #fff;
    color: #fff;
    &::after {
      content: '';
      position: absolute;
      right: 14px;
      bottom: 9px;
      width: 18px;
      height: 18px;
      border: 1px solid #e5f6ff;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-position: center;
    }
    &.is-checked {
      border-width: 2px;
      border-color: #7a99d1;
      &::after {
        border: 0;
        background-image: url(@/assets/img/form_radio.png);
      }
    }
    .pname {
      position: absolute;
      left: 0;
      top: 10px;
      line-height: 28px;
      background-color: #f41522;
      padding: 0 12px;
      font-weight: bold;
      color: #fff;
    }
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      display: flex;
      align-items: center;
      width: 100%;
      padding-top: 20px;
    }
    .info {
      overflow: hidden;
      font-size: 16px;
    }
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .nickname {
      font-weight: bold;
    }
    .time {
      color: #cfdff0;
    }
  }
  .auth_radio2 {
    width: 250px;
    height: 120px;
    background: #0d1f41;
    &.disabled {
      background: #1b202a;
      border: 1px solid #4c5360;
      .pname {
        background-color: #828282;
      }
      .time {
        opacity: 0.5;
      }
      &::after {
        display: none;
      }
    }
    &.is-checked {
      border: 1px solid #2f4e86;
    }
    .pname {
      top: 9px;
      line-height: 18px;
      background-color: #e34b4b;
      padding: 0 7px;
      font-weight: normal;
      font-size: 12px;
    }
    img {
      width: 38px;
      height: 38px;
      margin-right: 13px;
    }
    .nickname {
      font-weight: normal;
      font-size: 14px;
      color: #fff;
    }
    .time {
      @extend .ellipsis;
      font-size: 12px;
    }
    .info {
      line-height: 2;
    }
  }
  .auth_checkbox {
    @extend .auth_radio;
    &::after {
      border-radius: 0;
    }
    &.is-checked {
      &::after {
        background-image: url(@/assets/img/form_checkbox.png);
      }
    }
    .el-checkbox__input {
      display: none;
    }
    .el-checkbox__label {
      display: flex;
      align-items: center;
      width: 100%;
      padding-top: 20px;
      line-height: 2;
    }
    /* img {
      border-radius: 0;
    } */
    .mount {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 9;
      .el-link {
        --el-color-primary: #409eff;
      }
    }
  }
  .auth_checkbox2 {
    @extend .auth_radio2;
  }
  .el-radio-button {
    --el-radio-button-checked-bg-color: #1352ff;
    --el-button-text-color: var(--el-color-white);
    --el-radio-button-checked-border-color: #1352ff;
    --el-button-bg-color: #153878;
    --el-border-radius-base: 2px;
    .el-radio-button__inner {
      border: 0;
    }
  }
  .input_bg {
    background-color: #182d55;
    --el-input-border-color: #2f4e86;
  }
  .can_click {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .iframe {
    width: 100%;
    min-height: 100%;
    display: block;
  }
  .link_text {
    display: inline-flex;
    vertical-align: middle;
  }
  .el-upload-list__item {
    .lt {
      position: absolute;
      left: 0;
      top: 0;
      height: 25px;
      line-height: 25px;
      background: #0041bf;
      border-radius: 4px 0 4px 0;
      padding: 0 7px;
    }
    .el-progress {
      top: 11px;
    }
  }
  .el-container {
    height: 100vh;
  }
  .el-main {
    font-size: 14px;
    display: flex;
    flex-direction: column;
  }

  .material_list {
    /* display: flex;
    flex-wrap: wrap; */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 29px;
    li {
      /* width: 220px; */
      min-width: 220px;
      height: 290px;
      background-color: #0c224c;
      border: 1px solid #334f84;
      border-radius: 4px;
      position: relative;
      /* margin-right: 29px; */
      /* margin-bottom: 29px; */
      &.checked::before {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 32px;
        height: 29px;
        z-index: 9;
        background: url(@/assets/img/material_icon3.png) no-repeat;
      }
      .preview {
        height: 200px;
        padding: 25px 32px 3px;
        position: relative;
        &:hover {
          .mask {
            display: flex;
          }
        }
        > img {
          width: 100%;
          height: 100%;
        }
        .mask {
          display: none;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 9;
          background-color: rgba($color: #000000, $alpha: 0.5);
          justify-content: center;
          align-items: center;
        }
      }
      .info {
        border-top: 1px solid #3d5685;
        height: 83px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 14px 17px;
        .title {
          /* font-size: 18px; */
          line-height: 1.4;
        }
        .tool {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #9dbbff;
          img {
            position: relative;
            top: -1px;
          }
        }
        .delete {
          cursor: pointer;
        }
      }
      .lt {
        position: absolute;
        left: 0;
        top: 0;
        height: 25px;
        line-height: 25px;
        background: #0041bf;
        border-radius: 4px 0 4px 0;
        padding: 0 7px;
      }
    }
  }
  .material_flex {
    display: flex;
    .material_flex_class {
      margin-top: 20px;
      padding: 0 20px;
      flex: none;
      width: 235px;
      border-right: 1px solid #223c6c;
      .v2_btn {
        width: 100%;
      }
      ul {
        padding: 20px 0;
        li {
          margin-bottom: 15px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          border-radius: 5px;
          &.active {
            background-color: #195dff;
          }
          .dropdown_menu {
            padding: 0 10px;
          }
          .name {
            flex: auto;
          }
        }
      }
    }
    .content {
      flex: auto;
    }
  }
  .material_list1 {
    grid-template-columns: repeat(auto-fill, 220px);
    li {
      height: auto;
      margin-bottom: 30px;
      .preview {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 25px 32px;
        > img {
          width: auto;
          height: auto;
        }
        .duration {
          margin-top: 10px;
          background-color: #9a9999;
          line-height: 20px;
          border-radius: 10px;
          padding: 0 10px;
        }
      }
      > .name {
        position: absolute;
        width: 100%;
        left: 0;
        top: 100%;
        text-align: center;
        padding: 5px;
      }
    }
  }

  .upload_mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9;
    cursor: pointer;
  }

  .upload_template1 {
    .upload_item {
      width: 317px;
      height: 221px;
      background: #182d55;
      border-radius: 2px;
      border: 1px dashed #1352ff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 2;
      position: relative;
    }
    .tips {
      color: #6a7e94;
    }
  }
  .pr {
    position: relative;
  }
}
@keyframes infinite_scroll {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-50%);
  }
}
@for $i from 1 through 10 {
  @keyframes infinite_scroll#{$i} {
    0% {
      transform: translateY(0%);
    }
    @for $i2 from 1 through $i {
      #{$i2 * 1% * 100 / $i - 1%} {
        transform: translateY(-($i2 - 1) * 100 / $i / 2 * 1%);
      }
      #{$i2 * 1% * 100 / $i} {
        transform: translateY(-$i2 * 100 / $i / 2 * 1%);
      }
    }
  }
}

.drawer_template_list {
  width: 100%;
  .list {
    display: flex;
    flex-wrap: wrap;
  }
  .item {
    width: 132px;
    height: 234px;
    margin-right: 12px;
    margin-bottom: 12px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.el-button.el-button--danger {
  color: #ff4444;
  border-color: #ff4444;
}

.filter_select {
  .el-input {
    --el-input-height: 40px;
  }
}

.page_top {
  padding: 10px 24px 34px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 26px;
  .item {
    background: #192948;
    border-radius: 4px;
    border: 1px solid #334f84;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    .t1 {
      color: #7c97cb;
      margin-bottom: 10px;
    }
    .t2 {
      strong {
        font-size: 44px;
      }
    }
  }
}

.input_tag {
  .el-form-item__label {
    line-height: 40px;
  }
}

.dialog_full.el-dialog {
  height: 80vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    flex: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
}

body {
  .el-popper.is-dark {
    --el-bg-color: #fff;
    --el-text-color-primary: #172549;
    font-size: 14px;
  }
  .login {
    .el-input__wrapper {
      background: transparent;
    }
  }
  .el-input__wrapper,
  .el-input-number__decrease,
  .el-input-number__increase,
  .el-textarea__inner {
    background: #182d55;
  }
  .el-slider__button {
    background: #016fed;
    border: 3px solid #ffffff;
  }
  .el-color-picker__trigger {
    padding: 0;
  }
  .el-select,
  .search {
    max-width: 160px;
  }
  .el-select.full_select {
    max-width: none;
  }
  .el-form-item__label {
    .el-space__item:last-child {
      margin-right: 0 !important;
    }
  }
  .switch_inline.el-switch .el-switch__core {
    width: 60px;
    height: 22px;
    background: #4971df !important;
    border-color: #4971df !important;
  }

  .btn_flex {
    display: flex;
    .el-button {
      flex: 1;
    }
  }

  .white_select {
    background-color: #fff;
    --el-fill-color-light: #fff;
  }

  .el-checkbox__inner {
    background-color: #f8f8f8;
  }

  img[lazy='loading'] {
    width: 40px !important;
    margin: auto;
    display: block;
    object-fit: contain !important;
  }
  .table_nowarp {
    .cell {
      white-space: nowrap;
    }
  }
  .infinite_scroll_container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .flex_none {
      flex: none;
    }
    .flex_auto {
      flex: auto;
      overflow: auto;
    }
  }
  .space_flex {
    display: flex;
  }

  .submit_fixed {
    position: fixed;
    right: 40px;
    bottom: 62px;
    width: 308px;
    z-index: 99999;
  }
  .cp {
    cursor: pointer;
  }
  .flex_auto {
    flex: auto;
  }
  .flex_none {
    flex: none;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #182d55;
  }

  .el-select .el-select__tags .el-tag--info {
    background-color: #153878;
  }
  .el-link.link_flex {
    display: flex;
  }
  .el-link.link_baseline {
    vertical-align: baseline;
  }
  .space_fill {
    width: 100%;
  }
  .el-color-picker.is-disabled .el-color-picker__mask {
    display: none;
  }
}

.color_link {
  display: inline-block;
  cursor: pointer;
  color: $color;
  &:hover {
    opacity: 0.8;
  }
}

.drawer_header {
  .el-drawer__header {
    margin-bottom: 20px;
  }
}

.flex_dialog {
  display: flex;
  flex-direction: column;
  height: 90vh;
  .el-dialog__body {
    flex: auto;
    overflow: hidden;
  }
}

.scroll_dialog {
  height: 560px;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    flex: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
}

.infinite_scroll_dialog {
  height: 560px;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    flex: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
